// useStartDeal (Phase 55, D-23): the Start a deal entry points on the Clients
// page, the board card menu, and the contact page all call openStartDeal(contact).
// It opens the start dialog pre-filled from that contact; closing clears it.

import React from 'react';
import { buildStartDealPrefill } from '../utils/startDealPrefill';

export default function useStartDeal({ contacts, lenders, setShowStartTransactionModal }) {
    const [startDealContact, setStartDealContact] = React.useState(null);

    const openStartDeal = React.useCallback((contact) => {
        setStartDealContact(contact || null);
        setShowStartTransactionModal(true);
    }, [setShowStartTransactionModal]);

    const closeStartDeal = React.useCallback(() => {
        setStartDealContact(null);
        setShowStartTransactionModal(false);
    }, [setShowStartTransactionModal]);

    const prefill = React.useMemo(
        () => (startDealContact ? buildStartDealPrefill(startDealContact, { contacts: contacts || [], lenders: lenders || [] }) : undefined),
        [startDealContact, contacts, lenders]
    );

    return { prefill, openStartDeal, closeStartDeal };
}
